<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <!-- <el-breadcrumb-item>设备管理</el-breadcrumb-item> -->
                <el-breadcrumb-item>区域设备</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar" style="padding:0 1vw;">
              <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
              <el-button type="primary" @click="addRow()">添加区域设备</el-button>
            </div>
            <div class="build-table">
                <el-table :data="tableDataEnd" ref="tableDataBegin" height="100%" style="width: 100%;">
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                    <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="区域">
                    <template slot-scope="scope">
                    <a @click="toChild(scope.row)">{{ scope.row.blocksId}}</a>
                    </template>
                </el-table-column>
                <el-table-column label="设备类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.equipType=='1'">塔吊</span>
                      <span v-else-if="scope.row.equipType=='2'">高支模</span>
                      <span v-else-if="scope.row.equipType=='3'">监控</span>
                      <span v-else-if="scope.row.equipType=='4'">红外对射设备</span>
                    </template>
                </el-table-column>
                <el-table-column label="设备名">
                    <template slot-scope="scope">
                    <span>{{ scope.row.equipName }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="设备号">
                    <template slot-scope="scope">
                    <span>{{ scope.row.towerName }}</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="在线时间">
                    <template slot-scope="scope">
                    <span>{{ scope.row.updateDate }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                      <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>

                <!-- 新增窗口 -->
                <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="160px"
                    :label-position="labelPosition"
                    >
                    <!-- <el-form-item label="设备名称：">
                        <el-input v-model="addForm.name" autocomplete="off"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="区域：">
                      <el-select v-model="addForm.blocksId">
                        <el-option
                            v-for="item in blocksList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item> -->
                    <el-form-item label="设备类型：">
                      <el-select v-model="addForm.equipType" @change="typeChange">
                        <el-option
                            v-for="item in equipTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="绑定设备：">
                        <el-select v-model="addForm.equipId">
                          <el-option
                              v-for="item in equipList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                          ></el-option>
                        </el-select>
                    </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow()">确 定</el-button>
                    </div>
                </el-dialog>
                </el-table>

                <!-- 表单列表 -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20,50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import base from '../../untils/base'
import myHttp from '../../untils/port'
export default {
    data() {
    return {
      // projectId: '',
      // typeNameAll: [
      // ], // 类型下拉菜单组
      // status: '进闸', // 类型下拉菜单默认值
      // millNameAll: [], // 厂家下拉菜单组
      // machType: '零视', // 厂家下拉菜单默认值
      dialogTitle: '', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      addForm: {
        id:'',
        projectId:'',
        blocksId:'',
        equipType:'',
        equipId:'',
        equipName:''
      }, // 添加设备表单数组
      addFormVisible: false, // 弹出框是否显示
      tableDataEnd: [], // 考勤机表单数据
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      projectName: '',
      groupId: util.session.get('groupId'),
      dataText: '数据加载中...',
      // rules: {
      //   deviceId: [
      //     { required: true, message: '请输入', trigger: 'blur' }
      //   ],
      // },
      blocksList:[],//区域列表
      equipTypeList:[],//设备类型列表
      equipList:[],//设备列表
      pageTitle:'',//页面
      areaId:'',

    }
  },
  mounted() {
    var params = this.$route.params
    this.areaId  = params.id
    this.getAreaInfo()
    this.getList()
    this.getDict()
    // this.getDict1()
    // this.getTowerList()
    // this.getAreaMac()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getList()
    },
    // 监控当前页码
    currentChangePage() {
      this.getList()
    },
    //获取区域信息
    getAreaInfo(){
      var that = this
      myHttp.selectOneequipBlocks({
        id:this.areaId
      }).then(function (resp) {
          if (resp.data.code == '200') {
            // var list = resp.data.data.pageInfo.list || []
            // that.blocksList = list
            var data = resp.data.data.EquipBlocks
            that.pageTitle = data.name
          }
        },
        function () {
          that.dataText = '服务器繁忙中，请稍后请求'
        }
      )
    },

    //获取列表
    getList() {
      var option = {
        projectId: util.session.get('groupId'),
        pageSize:this.pageSize,
        pageNum:this.currentPage,
        blocksId:this.areaId
      }
      var that = this
      myHttp.getEquipBlocksEquipment(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              // list[i].statusName = that.filterSatus(list[i].nutUseType)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.pageInfo.total||0
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    //获取塔吊设备
    getTowerList(){
      var that = this
      myHttp.getListByTowerProjectId({
        projectId:this.groupId
      }).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.towerList || []
            that.towerList = list
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },

    //获取类型
    filterSatus(str){
      var list = this.typeNameAll
      var result = ''
      for(var i=0;i<list.length;i++){
        if(str == list[i].value){
          result = list[i].label
        }
      }
      return result
    },

    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑信息'
      this.addFormVisible = true
      this.addForm.id = row.id
      this.addForm.blocksId = row.blocksId
      this.addForm.equipType = row.equipType
      this.addForm.equipId = row.equipId
      this.addForm.equipName = row.equipName
      this.typeChange()
    },

    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteEquipBlocksEquipment({
            id: row.id,
            updateBy:util.session.get('user').id
        }).then(function(resp) {
          if (resp.data.code == '200') {
            that.$message.success('删除成功')
            that.getList()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },

    /**
     * 新增设备
     */
    addRow() {
      this.dialogTitle = '添加'
      this.addFormVisible = true
      this.addForm = {
        id: '',
        blocksId: this.areaId,
        equipType: '1',
        equipId: '',
        projectId: util.session.get('groupId'),
        createBy:'',
        equipName:''
      }
      this.typeChange()
    },

    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      if (that.addForm.id == '') {
        that.addForm.createBy = util.session.get("user").id
        that.addForm.equipName = this.getNameById(that.addForm.equipId)
        //添加
        myHttp.addEquipBlocksEquipment(that.addForm).then(
          function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('添加成功')
              that.addFormVisible = false
              that.currentPage = 1
              that.getList()
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
      } else {
        that.addForm.projectId = that.groupId
        that.addForm.updateBy = util.session.get("user").id
        that.addForm.equipName = this.getNameById(that.addForm.equipId)
        myHttp.updateEquipBlocksEquipment(that.addForm).then(
          function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('修改成功')
              that.addFormVisible = false
              that.getList()
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
      }
    },

    getNameById(id){
      var name = ''
      for(var i=0;i<this.equipList.length;i++){
        if(id==this.equipList[i].id){
          name = this.equipList[i].name
        }
      }
      return name
    },
    // cancel() {
    //   this.addFormVisible = false
    // },
    // 关闭弹出框弹窗
    // handleClose(done) {
    //   this.$confirm('确认关闭？')
    //     .then(_ => {
    //       done()
    //     })
    //     .catch(_ => {})
    // },
    // 字典接口
    // getPageList
    getDict() {
      var that = this
      myHttp.getDictByType({
        type: 'equip_type'
      }).then(function(resp) {
        if (resp.data.code == '200') {
          that.equipTypeList = resp.data.data.dictList
        } else {
          that.$message.error(resp.data.msg)
        }
      })
    },
    //根据类型获取数据
    typeChange(){
      if(this.addForm.equipType=='1'){
        this.getTowerList()
      }else if(this.addForm.equipType=='2'){
        this.getHight()
      }else if(this.addForm.equipType=='3'){
        this.getMonitor()
      }else if(this.addForm.equipType=='4'){
        this.getCrossList()
      }
    },  
    //塔吊
    getTowerList(){
      var that = this
      myHttp.getListByTowerProjectId({
        projectId:this.groupId,
        pageNum:1,
        pageSize:1000
      }).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.towerList || []
            that.equipList = list
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    //高支模
    getHight(){
      var that = this
      myHttp.selectTsDtuByPageList({
        groupId:this.groupId,
        pageSize:1000,
        pageNum:1
      }).then(
        function(resp) {
          if (resp.data.code == '200') {
            console.log(resp)
            var list = resp.data.data.PageInfo.list || []
            that.equipList = list
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    //监控
    getMonitor(){
      var that = this
      myHttp.getCameraPageListByProjectId({
          projectId:this.groupId,
          pageNum:1,
          pageSize:1000
      }).then(function(resp){
          if(resp.data.code=='200'){
              var list = resp.data.data.PageInfo.list||[];
              that.equipList = list
          }
      })
    },
    //红外对射设备
    getCrossList(){
      var option = {
        projectId: util.session.get('groupId'),
        pageNum:1,
        pageSize:1000
      }
      var that = this
      myHttp.getEquipCross(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            that.equipList = list
          }
        },
        function() {}
      )
    },

    //返回
    goBack(){
      this.$router.go(-1)
    },
    
  }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 8vh;
        /* border-top: 3px solid rgb(224, 224, 224); */
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-bar .btnLef {
        position: absolute;
        right: 6%;
        display: block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        border-radius: 4px;
        background: #ffaf15;
        border: 1px solid #ffb800;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 13vh );
        /* margin: 0 auto; */
    }

    .el-table .el-table-column:not(:first-child) {
        border: 1px solid slategrey;
    }

    .el-table >>> .cell {
        overflow: hidden;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
    }

    .add-form {
        margin-top: 10vh;
    }

    .add-form .el-form-item {
        margin-top: 30px;
    }

    .el-pagination {
        padding: 20px 0;
    }
</style>
<style>
@import '../../assets/css/common.css';
</style>